'use client';

import { useContentfulInspectorMode } from '@contentful/live-preview/react';

/**
 * Hidden element that registers a tagged entry with Contentful's inspector SDK
 * so the live preview iframe maintains communication with the editor.
 *
 * Uses a zero-size element with a specific fieldId to avoid triggering
 * the page-level dashed outline. The SDK needs at least one tagged element
 * to initialize properly.
 */
export const InspectorModeFallback = ({ entryId }: { entryId: string }) => {
  const inspectorProps = useContentfulInspectorMode({ entryId });

  return (
    <span
      {...inspectorProps({ fieldId: 'internalName' })}
      aria-hidden="true"
      style={{
        position: 'absolute',
        width: 0,
        height: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    />
  );
};
